<template>
  <div>
    <h1>Empresa</h1>
    <v-container grid-list-md>
      <v-toolbar
        color="transparent"
        flat
        dense
        v-if="this.$store.getters.isAdmin || this.$store.getters.isBranchAdmin"
      >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="saveCompany" text>Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout column>
        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md12>
                <v-text-field
                  id="name"
                  name="name"
                  label="Nome Fantasia"
                  v-model="company.name"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  id="taxName"
                  name="taxName"
                  label="Razão Social"
                  v-model="company.taxName"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  id="taxId"
                  name="taxId"
                  label="CNPJ"
                  v-model="company.taxId"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  id="registrationNumber"
                  name="registrationNumber"
                  label="Embratur"
                  v-model="company.registrationNumber"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  id="stateTaxId"
                  name="stateTaxId"
                  label="Inscrição Estadual"
                  v-model="company.stateTaxId"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex md12 mt-3>
          <AddressCard :address="company.address" />
        </v-flex>
        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md6>
                <v-text-field
                  id="website"
                  name="website"
                  label="Website"
                  v-model="company.website"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="email"
                  name="email"
                  label="e-mail"
                  v-model="company.email"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="phone"
                  name="phone"
                  label="Telefone(s)"
                  v-model="company.phone"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="fax"
                  name="fax"
                  label="Fax"
                  v-model="company.fax"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
  </div>
</template>
<script>
import api from "@/api";
import AddressCard from "@/components/Shared/AddressCard";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "customer-form",
  components: {
    AddressCard,
    OperationStatusCard
  },
  data() {
    return {
      company: {
        address: {}
      }
    };
  },
  methods: {
    saveCompany() {
      this.$refs.operationStatusCard.show();
      api
        .request("PUT", "/company", this.company)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    }
  },
  mounted() {
    this.$refs.loadingStatusCard.show();
    api
      .request("GET", "/company")
      .then(response => {
        this.company = response.data;
        this.$refs.loadingStatusCard.close();
      })
      .catch(error => {
        this.$refs.loadingStatusCard.fail(error.response.data);
      });
  }
};
</script>
